var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAibexSideLogoColor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 23.704 21.996",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-linear-gradient-svg",
    x1: 0.796,
    y1: 0.19,
    x2: 0.071,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e6af47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff3869"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-779.999 -435.308)",
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(779.999 435.308)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.276,5.151c-1.931-2.139-2.762-2.181-4.9-.25,2.139-1.931,2.181-2.762.25-4.9,1.931,2.139,2.762,2.181,4.9.25-2.139,1.931-2.181,2.762-.25,4.9",
    transform: "translate(-46.823 0)",
    fill: "#fc9819"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.615,22.619c-3.266-2.516-3.553-5.815-3.833-7.558a6.11,6.11,0,0,0,2.553-1.6,5.134,5.134,0,0,0,1.241-2.538l-4.322.015,0,0a5.3,5.3,0,0,0-4.8-3.785A5.528,5.528,0,0,0,15.027,9.49a5.98,5.98,0,0,1,4.735-.36,5.68,5.68,0,0,1,1.933,1.182,3.348,3.348,0,0,0-2.2,1.136,3.08,3.08,0,0,0-.7,1.544l2.65-.085a3.179,3.179,0,0,0,.773,1.946c-6.019-.034-10.54,2.313-11.175,5.253-.142.657-.539,3.071,1.062,4.619a6.108,6.108,0,0,0,2.048,1.258l6.043,0a5.667,5.667,0,0,1-1.672-.522,4.968,4.968,0,0,1-.648-.423c-.012-.01-.072-.057-.136-.112a3.838,3.838,0,0,1-1.51-3.447A3.779,3.779,0,0,1,18.86,18.8a4.023,4.023,0,0,1,3.335.612,8.342,8.342,0,0,0,.192,1.047,10.113,10.113,0,0,0,3.949,5.525l6.988-1.091a14.235,14.235,0,0,1-4.709-2.271m-4.724-10.6a.5.5,0,1,1-.5.5.5.5,0,0,1,.5-.5m1.423,9.821a8.2,8.2,0,0,1-1.573-6.508A10.5,10.5,0,0,0,25.867,21.7a11.788,11.788,0,0,0,3.49,3.054,9.449,9.449,0,0,1-4.043-2.914",
    transform: "translate(-10.889 -3.985)",
    fill: "url(#logo-linear-gradient-svg)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAibexSideLogoColor);
export default __webpack_public_path__ + "static/media/aibex-side-logo-color.22adcc687f0a7f5dfddce158d2d4b4ea.svg";
export { ForwardRef as ReactComponent };